import React, { useEffect, useState } from 'react';
import { OrderService } from './service/OrderService';
import { Button as PrimeButton } from 'primereact/button';
import { Card as PrimeCard } from 'primereact/card';
import { Fieldset } from 'primereact/fieldset';
import { SimpleGrid, Heading, VStack, Flex, background } from '@chakra-ui/react';
import { Panel } from 'primereact/panel';
import { Calendar } from 'primereact/calendar';
import { add, startOfWeek, endOfWeek, eachWeekOfInterval, isWithinInterval, formatISO, parseISO, isSameWeek, format } from 'date-fns';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { formatDay } from '../utils.js';


const EmployeeTasks = () => {
  const [employees, setEmployees] = useState([]);
  const [orders, setOrders] = useState([]);

  const [filterText, setFilterText] = useState(() => {
    const storedFilterText = localStorage.getItem('filterText');
    return storedFilterText || '';
  });
  const [sortOrder, setSortOrder] = useState(() => {
    const storedSortOrder = localStorage.getItem('sortOrder');
    return storedSortOrder || 'asc';
  });


  const defaultDateRange = {
    start: new Date().toISOString(),
    end: add(new Date(), { days: 90 }).toISOString()
  };

  const storedDateRange = localStorage.getItem('dateRange_');
  const initialDateRange = storedDateRange
    ? JSON.parse(storedDateRange)
    : defaultDateRange;


  const [dateRange, setDateRange] = useState({
    start: new Date(initialDateRange.start),
    end: new Date(initialDateRange.end)
  });

  useEffect(() => {
    Promise.all([OrderService.getEmployees(), OrderService.getOrdersByDateRange(dateRange.start, dateRange.end)])
      .then(([fetchedEmployees, fetchedOrders]) => {
        setEmployees(fetchedEmployees);
        setOrders(fetchedOrders);
        console.log("Orders: ", fetchedOrders);
        console.log("Employees: ", fetchedEmployees);
      })
      .catch((error) => {
        console.error('Error fetching employees and orders:', error);
      });
  }, [dateRange]);

  useEffect(() => {
    localStorage.setItem('sortOrder', sortOrder);
  }, [sortOrder]);

  useEffect(() => {
    localStorage.setItem('filterText', filterText);
  }, [filterText]);

 

  useEffect(() => {
    const storedDateRange = {
      start: dateRange.start.toISOString(),
      end: dateRange.end.toISOString()
    };
    localStorage.setItem('dateRange_', JSON.stringify(storedDateRange));
  }, [dateRange]);


  const getEmployeeTasks = (employeeName) => {
    const tasks = [];
    orders.forEach((order) => {
      order.orderItems?.forEach((item) => {
        const dueDate = new Date(order.dueDate);
        console.log('dueDate:', dueDate);
        console.log('dateRange.start:', dateRange.start);
        console.log('dateRange.end:', dateRange.end);
        if (isWithinInterval(dueDate, { start: dateRange.start, end: dateRange.end })) {
          // For cakes
          item.cakes.forEach((cake) => {
            if (cake.assignedBaker === employeeName) {
              tasks.push({
                type: 'Baking',
                productType: 'Cake',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cake.bakingNotes,
                  dueDate: cake.bakingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
            if (cake.assignedCrumbCoater === employeeName) {
              tasks.push({
                type: 'Crumb Coating',
                productType: 'Cake',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cake.crumbCoatingNotes,
                  dueDate: cake.crumbCoatDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
            if (cake.assignedDecorator === employeeName) {
              tasks.push({
                type: 'Decorating',
                productType: 'Cake',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cake.decoratingNotes,
                  dueDate: cake.decoratingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }

            cake.toppers.forEach((topper) => {
              if (topper.assignedPerson === employeeName) {
                tasks.push({
                  type: 'Topper',
                  productType: 'Cake',
                  taskDetails: topper,
                  orderInfo: {
                    name: order.name,
                    orderID: order.orderID ? order.orderID : null,
                    details: topper.description,
                    dueDate: topper.dueDate,
                    customer: order.customer.name,
                  },
                  employeeName: employeeName,
                });
              }
            });


            cake.decoratingItems.forEach((decoratingItem) => {
              if (decoratingItem.assignedDecorator === employeeName) {
                tasks.push({
                  type: 'Decorating',
                  productType: 'Cake',
                  taskDetails: decoratingItem,
                  orderInfo: {
                    name: order.name,
                    orderID: order.orderID ? order.orderID : null,
                    details: decoratingItem.decoratingNotes,
                    dueDate: decoratingItem.decoratingDate,
                    customer: order.customer.name,
                  },
                  employeeName: employeeName,
                });
              }
            });
          });

          // For cupcakes
          item.cupcakes.forEach((cupcake) => {
            if (cupcake.assignedBaker === employeeName) {
              tasks.push({
                type: 'Baking',
                productType: 'Cupcake',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cupcake.bakingNotes,
                  dueDate: cupcake.bakingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
            if (cupcake.assignedDecorator === employeeName) {
              tasks.push({
                type: 'Decorating',
                productType: 'Cupcake',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cupcake.decoratingNotes,
                  dueDate: cupcake.decoratingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
          });

          // For cake pops
          item.cakePops.forEach((cakePop) => {

            if (cakePop.assignedBaker === employeeName) {
              tasks.push({
                type: 'Baking',
                productType: 'Cake Pop',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cakePop.bakingNotes,
                  dueDate: cakePop.bakingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
            if (cakePop.assignedDecorator === employeeName) {
              tasks.push({
                type: 'Decorating',
                productType: 'Cake Pop',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cakePop.decoratingNotes,
                  dueDate: cakePop.decoratingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
          });

          // For cookies
          item.cookies.forEach((cookie) => {
            if (cookie.assignedBaker === employeeName) {
              tasks.push({
                type: 'Baking',
                productType: 'Cookie',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cookie.bakingNotes,
                  dueDate: cookie.bakingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
            if (cookie.assignedDecorator === employeeName) {
              tasks.push({
                type: 'Decorating',
                productType: 'Cookie',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: cookie.decoratingNotes,
                  dueDate: cookie.decoratingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
          });

          // For general items
          item.generalItems.forEach((generalItem) => {
            if (generalItem.assignedBaker === employeeName) {
              tasks.push({
                type: 'Baking',
                productType: 'General',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: generalItem.bakingNotes,
                  dueDate: generalItem.bakingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
            if (generalItem.assignedDecorator === employeeName) {
              tasks.push({
                type: 'Decorating',
                productType: 'General',
                taskDetails: order,
                orderInfo: {
                  name: order.name,
                  orderID: order.orderID ? order.orderID : null,
                  details: generalItem.decoratingNotes,
                  dueDate: generalItem.decoratingDate,
                  customer: order.customer.name,
                },
                employeeName: employeeName,
              });
            }
          });
          const filteredTasks = tasks.filter(
            (task) =>
              (task.orderInfo && task.orderInfo.name && task.orderInfo.name.toLowerCase().includes(filterText.toLowerCase())) ||
              (task.employeeName && task.employeeName.toLowerCase().includes(filterText.toLowerCase())) ||
              (task.type && task.type.toLowerCase().includes(filterText.toLowerCase())) ||
              (task.productType && task.productType.toLowerCase().includes(filterText.toLowerCase()))
          );

          // Return filtered tasks
          return filteredTasks;
        }
      });
    });
    return tasks;
  };

  const groupTasks = (tasks) => {
    let groupedTasks = {};

    tasks.forEach((task) => {
      const groupKey = groupBy === 'Order' ? task.orderInfo.name : task.type;

      if (!groupedTasks[groupKey]) {
        groupedTasks[groupKey] = [];
      }
      groupedTasks[groupKey].push(task);
    });

    return groupedTasks;
  };

  const groupTasksByDueDate = (tasks) => {
    const groupedTasks = {};

    tasks.forEach((task) => {
      const taskDate = parseISO(task.orderInfo.dueDate);
      //const formattedDate = formatISO(taskDate, { representation: 'date' });

      if (!groupedTasks[taskDate]) {
        groupedTasks[taskDate] = [];
      }

      groupedTasks[taskDate].push(task);
    });

    return groupedTasks;
  };


  const filteredTasks = employees.reduce((allTasks, employee) => {
    const employeeTasks = getEmployeeTasks(employee.name).map((task) => ({
      ...task,
      employeeName: employee.name,
    }));

    const filteredEmployeeTasks = employeeTasks.filter(
      (task) =>
        (task.orderInfo && task.orderInfo.name && task.orderInfo.name.toLowerCase().includes(filterText.toLowerCase())) ||
        (task.employeeName && task.employeeName.toLowerCase().includes(filterText.toLowerCase())) ||
        (task.type && task.type.toLowerCase().includes(filterText.toLowerCase())) ||
        (task.productType && task.productType.toLowerCase().includes(filterText.toLowerCase()))
    );

    return [...allTasks, ...filteredEmployeeTasks];
  }, []);


  const sortTasks = (groupedTasks) => {
    const sortedKeys = Object.keys(groupedTasks).sort((a, b) => new Date(a) - new Date(b));

    if (sortOrder === 'desc') {
      sortedKeys.reverse();
    }

    return sortedKeys.reduce((sortedTasks, key) => {
      sortedTasks[key] = groupedTasks[key];
      return sortedTasks;
    }, {});
  };


  const groupedTasks = sortTasks(groupTasksByDueDate(filteredTasks));


  const groupProductTypes = (tasks, groupBy) => {
    const grouped = {};

    tasks.forEach(task => {
      const groupKey = groupBy === 'Task Type' ? task.orderInfo.name : task.type;

      if (!grouped[groupKey]) {
        grouped[groupKey] = [];
      }

      const existingProductType = grouped[groupKey].find(pt => pt.productType === task.productType);

      if (!existingProductType) {
        grouped[groupKey].push({
          productType: task.productType,
          details: [task.orderInfo.details],
          orderID: task.orderInfo.orderID ? task.orderInfo.orderID : null,
        });
      } else {
        existingProductType.details.push(task.orderInfo.details);
      }
    });

    return grouped;
  };
  const [isAllCollapsed, setAllCollapsed] = useState(false);

  const [detailView, setDetailView] = useState(() => {
    const storedDetailView = localStorage.getItem('detailView');
    return storedDetailView ? storedDetailView === 'true' : false;
  });

  const [groupBy, setGroupBy] = useState(() => {
    const storedGroupBy = localStorage.getItem('groupBy');
    return storedGroupBy || 'Task Type';
  });


  const [columnCount, setColumnCount] = useState(localStorage.getItem('columnCount') || 3);

  useEffect(() => {
    const storedColumnCount = localStorage.getItem('columnCount');
    if (storedColumnCount) {
      setColumnCount(Number(storedColumnCount));
    }
    const storedDetailView = localStorage.getItem('detailView');
    if (storedDetailView) {
      setDetailView(storedDetailView === 'true');
    }
    const storedGroupBy = localStorage.getItem('groupBy');
    if (storedGroupBy) {
      setGroupBy(storedGroupBy);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('columnCount', Number(columnCount));
    localStorage.setItem('detailView', detailView.toString());
    localStorage.setItem('groupBy', groupBy);
  }, [columnCount, detailView, groupBy]);



  const increaseColumnCount = () => {
    setColumnCount((prevCount) => (prevCount < 15 ? prevCount + 1 : prevCount));
  };

  const decreaseColumnCount = () => {
    setColumnCount((prevCount) => (prevCount > 1 ? prevCount - 1 : prevCount));
  };



  const toggleCollapseAll = () => {
    const newPanelStates = {};
    const shouldCollapse = !isAllCollapsed;

    Object.keys(panelStates).forEach((index) => {
      newPanelStates[index] = shouldCollapse;
    });

    setAllCollapsed(shouldCollapse);
    setPanelStates(newPanelStates);
  };


  const [panelStates, setPanelStates] = useState({});

  const togglePanelCollapse = (index) => {
    setPanelStates((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <>
      <div>
        <PrimeButton
          onClick={() => setGroupBy(groupBy === 'Task Type' ? 'Order' : 'Task Type')}
          className="p-mb-3"
        >
          Group by {groupBy === 'Task Type' ? 'Order' : 'Task Type'}
        </PrimeButton>
        <PrimeButton
          onClick={() => setDetailView(!detailView)}
          className="p-mb-3"
        >
          {detailView ? 'Hide Details' : 'Show Details'}
        </PrimeButton>
        <PrimeButton
          onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
          className="p-mb-3"
        >
          Sort {sortOrder === 'asc' ? 'Descending' : 'Ascending'}
        </PrimeButton>
        <PrimeButton onClick={toggleCollapseAll} className="p-mb-3">
          {isAllCollapsed ? "Expand All" : "Collapse All"}
        </PrimeButton>
        <Calendar value={dateRange.start} onChange={(e) => setDateRange({ ...dateRange, start: e.value })} />
        <Calendar value={dateRange.end} onChange={(e) => setDateRange({ ...dateRange, end: e.value })} />
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Filter by Order, Employee, Task, or Item"
        />
        <PrimeButton onClick={increaseColumnCount} className="p-mb-3">
          Increase Columns
        </PrimeButton>
        <PrimeButton onClick={decreaseColumnCount} className="p-mb-3">
          Decrease Columns
        </PrimeButton>
      </div>
      <SimpleGrid columns={[1, columnCount]} spacing={4}>
        {Object.entries(groupedTasks).map(([key, tasks], index) => {
          const formatDate = (dateString) => {
            const date = new Date(dateString);

            const options = {
              month: '2-digit',
              day: '2-digit',
              year: '2-digit',
              weekday: 'long',
              timeZone: 'America/Chicago'
            };

            const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

            return `${formattedDate}`;
          };

          const formattedDate = formatDay(key);
          const header = <Heading size="md" key={`header-${index}`}>{formattedDate}</Heading>;

          const content = (
            <Flex wrap="wrap" justifyContent="left" gap="1rem" key={`content-${index}`}>
              {employees.map((employee) => {
                const employeeTasks = tasks.filter((task) => task.employeeName === employee.name);
                const groupedEmployeeTasks = groupTasks(employeeTasks);
                return (
                  employeeTasks.length > 0 ? (
                    // <PrimeCard
                    //   title={employee.name}
                    //   key={`primecard-${employee.name}`}
                    //   className="p-card-shadow p-card-w-title"
                    //   style={{ padding: '0.25rem', width: 'auto', minWidth: '20rem', }}
                    // >
                    <div style={{
                      //title with padding
                      paddingTop: '0.25rem',
                      paddingBottom: '0.25rem',
                      paddingLeft: '0.25rem',
                      paddingRight: '0.25rem',
                      //border
                      border: '1px solid #eaeaea',
                      borderRadius: '25px',
                      //background
                      background: '#f9f9f9',
                      //shadow
                      // boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                      //margin
                      marginBottom: '0.5rem',
                      marginTop: '0.5rem',
                      marginLeft: '0.5rem',
                      marginRight: '0.5rem',
                      //text
                      //textAlign: 'center',
                      //fontSize: '1rem',
                      //fontWeight: 'bold',
                      color: '#333',
                  }}>

                        <div style={{
                          fontSize: '1.5  5rem',
                          fontWeight: 'bold',
                          marginBottom: '0.5rem',
                          padding: '4px',
                          borderRadius: '15px',
                          backgroundColor: 'white',
                          border: '1px solid #eaeaea',
                          textAlign: 'center',
                          marginTop: '0.5rem',
                          marginLeft: '0.5rem',
                          marginRight: '0.5rem',
                        }}>
                          <strong> {employee.name}</strong>
                        </div>

                        <VStack spacing={1} align="start" key={`vstack-${employee.name}`}>
                          {Object.entries(groupedEmployeeTasks).map(([groupKey, groupTasks], groupIndex) => {
                            const groupedProductTypes = groupProductTypes(groupTasks, groupBy);

                            return (
                              <div style={{
                                //title with padding
                                paddingTop: '1rem',
                                paddingBottom: '1rem',
                                paddingLeft: '1rem',
                                paddingRight: '1rem',
                                //border
                                border: '1px solid #eaeaea',
                                borderRadius: '15px',
                                //background
                                background: 'white',
                                //shadow
                                // boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                //margin
                                marginBottom: '0.5rem',
                                marginTop: '0.5rem',
                                marginLeft: '0.5rem',
                                marginRight: '0.5rem',
                                //text
                                //textAlign: 'center',
                                //fontSize: '1rem',
                                //fontWeight: 'bold',
                                color: '#333',
                            }}>
                              <div key={`div-${groupKey}-${groupIndex}`}>
                                {/* <Panel header={groupKey} style={{ minWidth: '15rem', maxWidth: '18rem' }} key={`panel-${groupKey}`}> */}
                                <div style={{
                                  fontSize: '1.25rem',
                                  fontWeight: 'bold',
                                  marginBottom: '0.5rem',
                                  //padding: '8px',
                                  //borderRadius: '25px',
                                  //backgroundColor: '#e1f1fc',
                                  //textAlign: 'center',
                                  marginTop: '0.25rem',
                                }}>
                                  <strong> {groupKey}</strong>
                                </div>
                                {Object.entries(groupedProductTypes).map(([key, productTypes], index) => (
                                  <div key={`div-${key}-${index}`} style={{ marginBottom: '12px' }}>
                                    

                                      {productTypes.map(({ productType, orderID, }, ptIndex) => (
                                        <span key={`div-${productType}-${ptIndex}`}>
                                          {(
                                            <span style={{
                                              borderRadius: '10px',
                                              backgroundColor: orderID ? '#ededed' : 'transparent',
                                              paddingLeft: '6px',
                                              paddingRight: '6px',
                                              paddingTop: '2px',
                                              paddingBottom: '2px',
                                              fontWeight: 'bold',
                                            }}>
                                              {`${orderID ? orderID :'' }`}
                                            </span>
                                          )}
                                        </span>
                                      ))}{' '}
                                       {productTypes.map(({ productType, details }, ptIndex) => (
                                      <span key={`div-${productType}-${ptIndex}`}>
                                        { (
                                          <>
                                            {`${productType}`} {' - '}
                                          </>
                                        )}
                                      </span>
                                    ))}
                                      {`${key}`}
                                     
                                   
                                    {productTypes.map(({ productType, details }, ptIndex) => (
                                      <div style={{
                                        textAlign: 'right',
                                      }}>
                                      <div key={`div-${productType}-${ptIndex}`}>
                                        
                                        {//detailView &&
                                        details.join(', ').length > 2 &&
                                        (
                                          <>
                                            <i> {`Notes: `}</i>
                                            {/* <small> */}
                                              {details.join(', ')}
                                              {/* </small> */}
                                          </>
                                        )}
                                      </div>
                                      </div>
                                    ))}
                                  </div>
                                ))}
                                {/* </Panel> */}
                              </div>
                              </div>
                            );
                          })}
                        </VStack>
                      </div>
                    // </PrimeCard>
                  ) : null
                );
              })}
            </Flex>
          );

          return (
            <Panel header={header} key={`${index}`} toggleable collapsed={panelStates[index] !== undefined ? panelStates[index] : isAllCollapsed}
              onToggle={() => togglePanelCollapse(index)} style={{ display: 'inline-block' }}>
              {content}
            </Panel>
          );
        })}
      </SimpleGrid>
    </>
  );
};

export default EmployeeTasks;